import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Grid, Typography } from "@mui/material";
import AirplayIcon from "@mui/icons-material/Airplay";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useMemo } from "react";
import "./style.scss";
import { useNavigate } from "../../../Libraries/Dashboard";
import PropTypes from "prop-types"; // ES6

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
  height: "100%",
}));

const TemporaryDrawer = ({ toggleDrawer, isDrawerOpen, data }) => {
  const [searchVal, setSearchVal] = useState("");
  const navigate = useNavigate();

  const filteredData = useMemo(() => {
    if (searchVal.trim() === "") {
      return data;
    }
    return data.filter((dataItem) =>
      dataItem.txt_screen_name.toLowerCase().includes(searchVal.toLowerCase())
    );
  }, [data, searchVal]);

  const list = () => (
    <Box
      sx={{
        width: { xs: 250, sm: 250, xl: 450 },
        padding: { xs: 2, sm: 2, xl: "28px" },
      }}
      role="presentation"
    >
      <Box display={"flex"} flexDirection={"column"}>
        <Typography variant="h2">Last watch</Typography>
        <div className="nosubmitwrapper">
          <form className="nosubmit">
            <input
              className="nosubmit"
              type="search"
              placeholder="Search..."
              onChange={(e) => setSearchVal(e.target.value)}
            />
          </form>
        </div>
      </Box>
      <Grid container spacing={2}>
        {filteredData?.map((alphabet, index) => {
          return (
            <Grid item key={index}>
              <Box
                className="box surface-0"
                width={188}
                height={214}
                borderRadius={2}
                marginTop={2}
                sx={{ backgroundColor: "#FFFFFF!important", cursor: "pointer" }}
                marginLeft={"0px"}
              >
                <Item onClick={() => gotoScreen(alphabet)} tabIndex={index}>
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    height={"100%"}
                  >
                    <Box
                      padding={2}
                      borderRadius={100}
                      bgcolor={"#EFF3FC"}
                      width={100}
                      height={100}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      flexDirection={"column"}
                    >
                      <AirplayIcon />
                      <Typography
                        fontSize={"12px"}
                        lineHeight={2}
                        noWrap
                        overflow={"hidden"}
                        width={"10ch"}
                        textAlign={"center"}
                      >
                        {alphabet.txt_screen_name}
                      </Typography>
                    </Box>
                    <Box marginTop={2}>
                      <Typography fontSize={12}>
                        Last seen:
                        {alphabet.last_seen}
                      </Typography>
                      <Typography textAlign={"center"} fontSize={12}>
                        Mapped:
                        {alphabet.is_mapped_flag}
                      </Typography>
                    </Box>
                  </Box>
                </Item>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );

  function gotoScreen(screen) {
    navigate("/posts", {
      state: [
        {
          value: screen.ser_screen_id,
          label: screen.txt_screen_name,
        },
      ],
    });
  }

  return (
    <div>
      <Drawer
        anchor={"right"}
        open={isDrawerOpen}
        onClose={(e) => toggleDrawer(e, false)}
        PaperProps={{
          sx: {
            backgroundColor: "rgba(240, 240, 240, 0.88)",
          },
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
};

TemporaryDrawer.propTypes = {
  toggleDrawer: PropTypes.func,
  isDrawerOpen: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
};

export default TemporaryDrawer;
